function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  fill: "#4dd0e1",
  r: 22
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#012e52"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.566 27.605c-.771.792-.753 2.058.039 2.828l6.562 6.382c.756.766 1.762 1.188 2.833 1.188s2.077-.422 2.805-1.159l6.59-6.41c.792-.77.81-2.036.039-2.828-.77-.793-2.037-.808-2.828-.039l-6.621 6.41-6.59-6.41c-.791-.77-2.059-.754-2.829.038z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.283 12.19c1.762-.252 3.672-.252 5.434 0 .097.014.191.021.286.021.979 0 1.834-.72 1.977-1.717.156-1.094-.604-2.107-1.696-2.263-2.137-.305-4.43-.305-6.566 0-1.093.156-1.853 1.169-1.696 2.263.155 1.093 1.179 1.855 2.261 1.696z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32 56c13.233 0 24-10.767 24-24 0-9.061-5.016-17.253-13.09-21.381-.984-.503-2.188-.112-2.691.87-.502.984-.112 2.188.871 2.691 6.729 3.441 10.91 10.269 10.91 17.82 0 11.028-8.972 20-20 20s-20-8.972-20-20c0-7.551 4.181-14.379 10.91-17.819.983-.503 1.373-1.708.871-2.691-.503-.982-1.707-1.373-2.691-.87-8.074 4.127-13.09 12.319-13.09 21.38 0 13.233 10.767 24 24 24z"
}));

var SvgDownArrow = function SvgDownArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down-arrow.35cd5816.svg";
export { ForwardRef as ReactComponent };